import { type FC, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '@assets/img/icons/chevron.svg?react';
import WalletIcon from '@assets/img/icons/wallet.svg?react';
import {
  useTonAddress,
  useTonConnectModal,
  useTonWallet,
} from '@tonconnect/ui-react';

import { toShortWalletAddress } from '@/common/lib/toShortWalletAddress';
import { ModalContext } from '@/components/Modals/Modal/config';
import { H3, StringMain } from '@/components/Typography/Typography';
import { Button } from '@/components/ui/Button/Button';

import css from './styles.module.scss';

interface TonConnectButtonProps {
  className?: string;
}

const TonConnectButton: FC<TonConnectButtonProps> = ({ className }) => {
  const { t } = useTranslation();
  const { openModal } = useContext(ModalContext);
  const { open } = useTonConnectModal();
  const wallet = useTonWallet();
  const address = useTonAddress();

  useEffect(() => {
    console.log(wallet);
  }, [wallet]);

  const onClick = (): void => {
    if (wallet && address) {
      openModal({
        renderKind: 'tonWalletInfo',
        props: undefined,
      });
    } else {
      open();
    }
  };

  return (
    <Button onClick={onClick} className={className} variant="transparent">
      <div className="h-12 w-full flex items-center gap-2.5 rounded-lg bg-surface pl-4 pr-2">
        <WalletIcon className="w-6 h-6 mr-1" />
        <StringMain className="mr-auto">{t('Wallet')}</StringMain>
        <H3 weight="medium" className={css.textShadow}>
          {wallet && address ? toShortWalletAddress(address) : t('Connect')}
        </H3>
        <ChevronIcon className="w-6 h-6 text-white/40" />
      </div>
    </Button>
  );
};

export { TonConnectButton };
